/** A count with thousands separators, e.g. 43,549. */
export function formatCount(value: number, lang: string): string {
  return new Intl.NumberFormat(lang).format(value);
}

/**
 * `scanPct` arrives as a percentage already (95.28), and is null for a route
 * with nothing to scan yet -- which is not 0%.
 */
export function formatPercent(
  value: number | null | undefined,
  lang: string,
): string | undefined {
  if (value === null || value === undefined) return undefined;
  return `${new Intl.NumberFormat(lang, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value)}%`;
}

/** 3725 -> "1h 02m". Under an hour drops the hours: 125 -> "2m". */
export function formatDuration(totalSeconds: number): string {
  const minutes = Math.floor(totalSeconds / 60);
  const hours = Math.floor(minutes / 60);
  if (hours === 0) return `${minutes}m`;
  return `${hours}h ${String(minutes % 60).padStart(2, "0")}m`;
}

/**
 * How a scan rate reads on its bar: a route scanning nearly everything is
 * fine, a middling one is worth a look, a poor one is a problem. The
 * thresholds are ours -- the service sends only the percentage.
 */
export function scanTone(pct: number): "good" | "fair" | "poor" {
  if (pct >= 95) return "good";
  if (pct >= 80) return "fair";
  return "poor";
}
